document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-element="header"]');
    const menuOpenBtn = document.querySelector('[data-element="mobile-menu-open"]');
    const menu = document.querySelector('[data-element="mobile-menu"]');
    const html = document.getElementsByTagName('html')[0];
    const headerBurger = document.querySelector('.js-header-burger');
    const servicesMenuBtn = document.querySelector('.js-header-services-menu-btn');
    const servicesMenu = document.querySelector('.js-header-services-menu');
    const showChildHeaderMenu = document.querySelectorAll('.js-header-show-children')

    if (header && menuOpenBtn && menu) headerInit()

    let currentScrollPosition

    function headerInit () {
        window.addEventListener('scroll', checkScroll);
        if (header.getBoundingClientRect().top + pageYOffset !== 16 && header.getBoundingClientRect().top + pageYOffset !== 20) checkScroll();

        menuOpenBtn.addEventListener('click', toggleMenu);

        if (servicesMenuBtn && servicesMenu) {
            initHeaderServicesMenu();
            initHeaderMobileServicesMenu();
            initHeaderMobileSubMenu();
        }

        if(showChildHeaderMenu) {
            showChildHeaderMenu.forEach((key, val) => {
                key.addEventListener('click', toggleChildrenHeaderMenu)
            });
        }
    }

    function closeMenu () {
        html.classList.remove('html_no-scroll');
        menu.classList.remove('mobile-menu_active');
        headerBurger.classList.remove('is-opened');
        window.scrollTo(0, currentScrollPosition)
        menu.querySelectorAll('.is-active').forEach(item => item.classList.remove('is-active'));
    }

    function openMenu () {
        currentScrollPosition = pageYOffset;
        html.classList.add('html_no-scroll');
        menu.classList.add('mobile-menu_active');
        headerBurger.classList.add('is-opened');
    }

    function toggleMenu ({target}) {
        const btn = target.closest('.js-header-burger');

        if (!btn) return;

        if (menu.classList.contains('mobile-menu_active')) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    function checkScroll () {
        const topPosition = header.getBoundingClientRect().top + pageYOffset
        if (topPosition > 0) {
            header.classList.add('header_scroll')
        } else {
            header.classList.remove('header_scroll')
        }
    }

    function initHeaderServicesMenu () {
        const activeMenuItems = servicesMenu.getElementsByClassName('js-header-services-menu-main-item is-active');

        servicesMenuBtn.addEventListener('click', () => {
            servicesMenu.classList.toggle('is-active');
            servicesMenuBtn.classList.toggle('header__nav-link_active');
        });

        document.body.addEventListener('click', ({target}) => {
            const menu = target.closest('.js-header-services-menu');

            if (!target.closest('.js-header-services-menu, .js-header-services-menu-btn')) {
                servicesMenu.classList.remove('is-active');
                servicesMenuBtn.classList.remove('header__nav-link_active');
                return;
            }

            if (menu) {
                const menuItem = target.closest('.js-header-services-menu-main-item');

                if (menuItem && !menuItem.classList.contains('is-active')) {
                    const menuList = document.getElementById(menuItem.dataset.target);

                    if (menuList) {
                        const [activeMenuItem] = activeMenuItems;
                        const activeMenuList = document.getElementById(activeMenuItem.dataset.target);

                        activeMenuItem.classList.remove('is-active');
                        activeMenuList.classList.remove('is-active');
                        menuItem.classList.add('is-active');
                        menuList.classList.add('is-active');
                    }
                }
            }
        })
    }

    function initHeaderMobileServicesMenu () {
        menu.addEventListener('click', ({target}) => {
            const menuBtn = target.closest('.js-mobile-services-menu-btn');
            const backBtn = target.closest('.js-mobile-services-menu-black');

            if (menuBtn) {
                document.getElementById(menuBtn.dataset.target).classList.add('is-active');
            }

            if (backBtn) {
                backBtn.closest('.is-active')?.classList.remove('is-active');
            }
        });
    }

    function initHeaderMobileSubMenu() {
        menu.addEventListener('click', ({target}) => {
            const menuBtn = target.closest('.js-mobile-sub-menu-btn');
            const backBtn = target.closest('.js-mobile-sub-menu-black');

            if (menuBtn) {
                document.getElementById(menuBtn.dataset.target).classList.add('is-active');
            }

            if (backBtn) {
                backBtn.closest('.is-active')?.classList.remove('is-active');
            }
        });
    }

    function toggleChildrenHeaderMenu() {
        this.classList.toggle("active")

        document.body.addEventListener('click', ({target}) => {

            if (!target.closest('.js-header-show-children')) {
                this.classList.remove('active');
                return;
            }
        })
    }
});
